const GlobalAlerts = {
  init: function() {
    const message = localStorage.getItem('vexpenses-alert-message') || ''
    const type = localStorage.getItem('vexpenses-alert-type') || 'success'
    const container = localStorage.getItem('vexpenses-alert-container') || 'floating'
    const title = localStorage.getItem('vexpenses-alert-title') || ''
    const timer = localStorage.getItem('vexpenses-alert-timer') || 5000

    if (message.length) {
      $.niftyNoty({
        type: type,
        container: container,
        title: title,
        message: message,
        closeBtn: true,
        timer: timer
      })
    }

    this.clear();
  },

  clear: function() {
    localStorage.removeItem('vexpenses-alert-message')
    localStorage.removeItem('vexpenses-alert-type')
    localStorage.removeItem('vexpenses-alert-container')
    localStorage.removeItem('vexpenses-alert-title')
    localStorage.removeItem('vexpenses-alert-timer')
  },

  create: function(alertObj) {
    alertObj = alertObj || {};

    const message = alertObj.message || '';
    const type = alertObj.type || '';
    const container = alertObj.container || '';
    const title = alertObj.title || '';
    const timer = alertObj.timer || 5000;

    localStorage.setItem('vexpenses-alert-message', message)
    localStorage.setItem('vexpenses-alert-type', type)
    localStorage.setItem('vexpenses-alert-container', container)
    localStorage.setItem('vexpenses-alert-title', title)
    localStorage.setItem('vexpenses-alert-timer', timer)
  },

  createAndShow: function(alertObj) {
    this.create(alertObj);
    this.init();
  }
}

module.exports = GlobalAlerts;

